import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { LobMaintenanceComponent } from "./lob-maintenance/lob-maintenance.component";
import { MaintenanceRoutingModule } from "./maintenance-routing-module";
import { OrgMaintenanceV4Component } from "./org-maintenance-v4/org-maintenance-v4.component";
import { LobAddPopupComponent } from "./lob-maintenance/lob-add-popup/lob-add-popup.component";
import { MatRadioModule } from "@angular/material/radio";
import { MaintenanceTableV4Component } from "./maintenance-table-v4/maintenance-table-v4.component";
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ChartsModule } from "../../padu-reporting/charts/charts.module";
import { SharedComponentsModule } from "../../shared/shared-components.module";
import { CommonModule } from "@angular/common";
import { ModalModule } from 'ng-modal-lib-sab';
import { DeleteLobComponent } from "./lob-maintenance/delete-lob/delete-lob.component";
import { LobBulkEditComponent } from "./lob-maintenance/lob-bulk-edit/lob-bulk-edit.component";
import { AssignLeaderPopUpComponent } from './decom-lob/assign-leader-pop-up/assign-leader-pop-up.component';
import { FundMaintenanceComponent } from './capital-demand/fund-maintenance/fund-maintenance.component';
import { FundMaintenanceV4Component } from './capital-demand/fund-maintenance-table/fund-maintenance-table.component';
import { AddSegmentComponent } from './capital-demand/fund-maintenance/add-segment/add-segment.component';
import { EditSegmentComponent } from './capital-demand/fund-maintenance/edit-segment/edit-segment.component';
import { CapitalMaintenanceV4Component } from './capital-demand/capital-maintenance-table/capital-maintenance-table.component';
import { CapitalMaintenanceComponent } from './capital-demand/capital-maintenance/capital-maintenance.component';
import { OptumTechLabourComponent } from "./capital-demand/optum-tech-labour/optum-tech-labour.component";
import { AddUcmgComponent } from "./capital-demand/add-ucmg/add-ucmg.component";
import { EditUcmgComponent } from "./capital-demand/edit-ucmg/edit-ucmg.component";
import { ViewCommentsComponent } from "./capital-demand/view-comments/view-comments.component";
import { ThousandPipeModule } from '../../shared';
import { MatSortModule } from "@angular/material/sort";
import { DecomLobComponent } from "./decom-lob/decom-lob.component";
import { LobAddRemoveArchitectComponent } from "./lob-maintenance/lob-add-remove-architect/lob-add-remove-architect.component";
import { EnterpriseInitiativeRoleManagementComponent } from './enterprise-initiative-role-management/enterprise-initiative-role-management.component';
import { MatTreeModule } from "@angular/material/tree";
import { AddRolePopupComponent } from "./enterprise-initiative-role-management/add-role-popup/add-role-popup.component";
import { SubLobDecomAssignmentComponent } from "./decom-lob/sub-lob-decom-assignment/sub-lob-decom-assignment.component";
import { EnterpriseInitiativesComponent } from "./enterprise-initiatives/enterprise-initiatives.component";
import { ForecastManagementComponent } from "./forecast-management/forecast-management.component";
import { MultiLineChartComponent } from "../../shared/elements/multi-line-chart/multi-line-chart.component";
import { ForecastManagementServiceDetailComponent } from "./forecast-management/forecast-management-service-detail/forecast-management-service-detail.component";
import { ForecastMasterCardComponent } from "./forecast-management/forecast-management-service-detail/forecast-master-card/forecast-master-card.component";
import { BulkForecastComponent } from "./forecast-management/bulk-forecast/bulk-forecast.component";
import { ForecastMasterTableComponent } from "./forecast-management/forecast-master-table/forecast-master-table.component";
import { IntegerOnlyDirective } from "../../shared/directives/integeronly.directive";
import { ForcastManagementTableComponent } from './forecast-management/forcast-management-table/forcast-management-table.component';
import { ForecastAddServicePopupComponent } from "./forecast-management/forcast-management-table/forecast-add-service-popup/forecast-add-service-popup.component";
import { AddEditForecastMasterComponent } from './forecast-management/forecast-master-table/add-edit-forecast-master/add-edit-forecast-master.component';
import { ForecastDetailsCardComponent } from "./forecast-management/forecast-detail-card/forecast-detail-card.component";
import {MatDatepickerModule} from '@angular/material/datepicker';
import { EnterpriseInitiativeFieldManagementComponent } from "./enterprise-initiative-field-management/enterprise-initiative-field-management.component";
import { FieldManagementTableComponent } from './enterprise-initiative-field-management/field-management-table/field-management-table.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EnableFieldPopupComponent } from "./enterprise-initiative-field-management/enable-field-popup/enable-field-popup.component";
import { AddRemovePopupComponent } from "./add-remove-popup/add-remove-popup.component";
import { EditRolePopupComponent } from "./enterprise-initiative-role-management/edit-role-popup/edit-role-popup.component";
import { BulkMaintenanceComponent } from "./bulk-maintenance/bulk-maintenance.component";
import { DisableDragDropDirective } from "../../shared/directives/disable-drag-drop.directive";
import { UCMGListViewComponent } from "./capital-demand/ucmg-list-view/ucmg-list-view.component";

import { UserManagementComponent } from "./lob-maintenance/user-management/user-management.component";
import { ForecastRoleManagementComponent } from './forecast-management/forecast-role-management/forecast-role-management.component';
import { ForecastAdminManagementComponent } from './forecast-management/forecast-admin-management/forecast-admin-management.component';
import { ForecastServiceManagmentTableComponent } from "./forecast-management/forecast-service-managment-table/forecast-service-managment-table.component";
import { HeirarchyMismatchComponent } from "./capital-demand/heirarchy-mismatch/heirarchy-mismatch.component";
import { AddEditForecastServiceComponent } from "./forecast-management/forecast-service-managment-table/add-edit-forecast-service/add-edit-forecast-service.component";
import { AddEditForecastRoleManagementComponent } from './forecast-management/forecast-role-management/add-edit-forecast-role-management/add-edit-forecast-role-management.component';
import { CapitaldemandBulkEditComponent } from "./capital-demand/capitaldemand-bulk-edit/capitaldemand-bulk-edit.component";
import { OtLaborProposalComponent } from "./capital-demand/ot-labor-proposal/ot-labor-proposal/ot-labor-proposal.component";
import { MyPropApprovalsComponent } from "./capital-demand/ot-labor-proposal/my-prop-approval/my-prop-approvals/my-prop-approvals.component";
import { MyPropRequestsComponent } from "./capital-demand/ot-labor-proposal/my-prop-request/my-prop-requests/my-prop-requests.component";
import { PropTableComponent } from "./capital-demand/ot-labor-proposal/prop-table/prop-table.component";
import { ProposalPopupComponent }  from "./capital-demand/ot-labor-proposal/prop-table/proposal-popup/proposal-popup.component";
import { ForecastMultiMatrixComponent } from './forecast-management/forecast-multi-matrix/forecast-multi-matrix.component';
import { AddEditForecastMultiMatrixComponent } from './forecast-management/forecast-multi-matrix/add-edit-forecast-multi-matrix/add-edit-forecast-multi-matrix.component';
import { ForecastSegmentRelationshipComponent } from './forecast-management/forecast-segment-relationship/forecast-segment-relationship.component';
import { CapitalInvestmentSummaryLeaderComponent } from "./capital-demand/capital-investment-summary-leader/capital-investment-summary-leader.component";
import {CapitalDemandTableComponent} from "./capital-demand/capital-investment-summary-leader/capital-demand-leader-table/capital-demand-leader-table.component";
import { RulesEngineComponent } from "./rules-engine/rules-engine.component";
import { DecomLobAddEditPopupComponent } from './decom-lob/decomLob-add-edit-popup/decomLob-add-edit-popup.component';
import { CustomNumbersAutofilterComponent } from "../../shared/components/custom-numbers-autofilter/custom-numbers-autofilter.component";
import { MillionsToMThousandsToK } from "../../shared/pipe/millionsToM-thousandsToK.pipe";
import { BillionsToBMillionsToMThousandsToK } from "../../shared/pipe/billionsToB-millionsToM-thousandsToK.pipe";
import { FilterPipe } from "../../filter.pipe";
import { CreateGroupComponent } from "./group-maintenance/create-group/create-group.component";
import { EditGroupComponent } from "./group-maintenance/edit-group/edit-group.component";
import { GroupMaintenanceComponent } from "./group-maintenance/group-maintenance.component";
import { ShareGroupComponent } from "./group-maintenance/share-group/share-group.component";
import { ViewGroupComponent } from "./group-maintenance/view-group/view-group.component";
import { GroupMaintenanceTableComponent } from "./shared/group-maintenance-table/group-maintenance-table.component";
import { MaintenanceModalComponent } from "./shared/maintenance-modal/maintenance-modal.component";
import { MydownloadsComponent } from './mydownloads/mydownloads.component';
import { ReportModule } from '../../reports/reports.module';

@NgModule({
    declarations: [LobMaintenanceComponent,
        ForecastDetailsCardComponent,
        OrgMaintenanceV4Component,
        MaintenanceTableV4Component,
        LobAddPopupComponent,
        DeleteLobComponent,
        LobBulkEditComponent,
        AssignLeaderPopUpComponent,
        FundMaintenanceComponent,
        FundMaintenanceV4Component,
        OptumTechLabourComponent,
        AddSegmentComponent,
        EditSegmentComponent,
        CapitalMaintenanceComponent,
        AddUcmgComponent,
        EditUcmgComponent,
        CapitalMaintenanceV4Component,
        UCMGListViewComponent,
        DecomLobComponent,
        LobAddRemoveArchitectComponent,
        EnterpriseInitiativeRoleManagementComponent,
        AddRolePopupComponent,
        SubLobDecomAssignmentComponent,
        EnterpriseInitiativesComponent,
        ForecastManagementComponent,
        MultiLineChartComponent,
        ForecastManagementServiceDetailComponent,
        ForecastMasterCardComponent,
        ForecastMasterTableComponent,
        BulkForecastComponent,
        IntegerOnlyDirective,
        ForcastManagementTableComponent,
        ForecastAddServicePopupComponent,
        AddEditForecastMasterComponent,
        EnterpriseInitiativeFieldManagementComponent,
        FieldManagementTableComponent,
        AddRemovePopupComponent,
        EditRolePopupComponent,
        EnableFieldPopupComponent,
        ViewCommentsComponent,
        BulkMaintenanceComponent,
        DisableDragDropDirective,
        UserManagementComponent,
        ForecastRoleManagementComponent,
        ForecastAdminManagementComponent,
        ForecastServiceManagmentTableComponent,
        AddEditForecastServiceComponent,
        HeirarchyMismatchComponent,    
        AddEditForecastRoleManagementComponent,
        CapitaldemandBulkEditComponent,
        OtLaborProposalComponent,
        MyPropApprovalsComponent,
        MyPropRequestsComponent,
        PropTableComponent,
        ProposalPopupComponent,
        AddEditForecastMultiMatrixComponent,
        ForecastMultiMatrixComponent,
        ForecastSegmentRelationshipComponent,
        CapitalInvestmentSummaryLeaderComponent,
        CapitalDemandTableComponent,
        RulesEngineComponent,
        DecomLobAddEditPopupComponent,
        MaintenanceModalComponent,
        GroupMaintenanceComponent,
        GroupMaintenanceTableComponent,
        CreateGroupComponent,
        ViewGroupComponent,
        EditGroupComponent,
        ShareGroupComponent,
        FilterPipe,
        MydownloadsComponent
    ],
    imports: [MaintenanceRoutingModule,
        MatRadioModule,
        MatAutocompleteModule,
        ChartsModule,
        MatChipsModule,
        MatDialogModule,
        MatButtonModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatInputModule,
        MatSelectModule,
        MatSidenavModule,
        MatIconModule,
        MatTabsModule,
        MatTooltipModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatTableModule,
        MatCheckboxModule,
        MatListModule,
        MatMenuModule,
        MatGridListModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        CommonModule,
        SharedComponentsModule,
        CommonModule,
        ModalModule,
        ThousandPipeModule,
        MatSortModule,
        MatTreeModule,
        MatDatepickerModule,
        DragDropModule,
        ReportModule,
        CustomNumbersAutofilterComponent,
        MillionsToMThousandsToK,
        BillionsToBMillionsToMThousandsToK
    ],
    exports: [
        MaintenanceTableV4Component
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA]
})
export class maintenanceModuleV4 { }
